export default __webpack_public_path__ + "static/The Home_Image 5_carousel 2@2x-128cc5a1b6cf43f369f0cbae9642175f.jpg";